/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, Input } from '@angular/core';
import { Color } from '@ionic/core';

@Component({
  selector: 'app-spinner-circle',
  templateUrl: './spinner-circle.component.html',
  styleUrls: ['./spinner-circle.component.scss']
})
export class SpinnerCircleComponent {
  /**
   * icona
   */
  @Input() icon: string;

  /**
   * colore
   */
  @Input() color: Color = 'primary';

  /**
   * flag per bloccare l'animazione
   */
  @Input() blocked = false;
}
